/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import Dropzone from 'react-dropzone';
import {
  Row, Col, Card, Progress, Alert,
} from 'reactstrap';
import { isNull } from 'lodash';
import { Link } from 'react-router-dom';
import { post } from '../../helpers/api_helper';

import * as url from '../../helpers/url_helper';

function GoogleFiles(props) {
  const { bucket } = props;
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [errorMessage, setErrorMessage] = useState(null);

  /**
   * Formats the size of a file
   */
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
  };

  async function handleAcceptedFiles(acceptedFiles) {
    // previews
    const select = acceptedFiles;

    select.map((file) => Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    }));
    setSelectedFiles(select);

    try {
      const formData = new FormData();
      formData.append('bucket', bucket);

      for (let i = 0; i < acceptedFiles.length; i += 1) {
        formData.append('files', acceptedFiles[i]);
      }

      const response = await post(url.GOOGLE_POST_FILES, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          setUploadProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
        },
      });

      for (let i = 0; i < response.urls.length; i += 1) {
        props.onFileUpload(response.urls[i]);
      }
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setSelectedFiles([]);
    }
  }

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  return (
    <>
      <Dropzone
        onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}
      >
        {({ getRootProps, getInputProps }) => (
          <div className="dropzone">
            <div
              className="dz-message needsclick"
              {...getRootProps()}
            >
              <input {...getInputProps({ name: 'file' })} />
              <div className="mb-3">
                <i className="display-4 text-muted bx bxs-cloud-upload" />
              </div>
              <h4>{props.t('Drop files here or click to upload.')}</h4>
            </div>
          </div>
        )}
      </Dropzone>
      <div
        className="dropzone-previews mt-3 mb-3"
        id="file-previews"
      >
        { em }
        {selectedFiles.map((f, i) => (
          <Card
            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
            // eslint-disable-next-line react/no-array-index-key
            key={`${i}-file`}
          >
            <div className="p-2">
              <Row className="align-items-center">
                <Col className="col-auto">
                  <img
                    data-dz-thumbnail=""
                    height="80"
                    className="avatar-sm rounded bg-light"
                    alt={f.name}
                    src={f.preview}
                  />
                </Col>
                <Col>
                  <Link
                    to="/#"
                    className="text-muted font-weight-bold"
                  >
                    {f.name}
                  </Link>
                  <div>
                    <strong>{f.formattedSize}</strong>
                    <Progress value={uploadProgress} color="warning" striped animated className="mt-1" />
                  </div>
                </Col>
              </Row>
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}

GoogleFiles.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  onFileUpload: PropTypes.func.isRequired,
  bucket: PropTypes.string.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(GoogleFiles));
